export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      cabinet: "Le Cabinet",
      services: "Nos Services",
      documents: "Documents à fournir",
      appointment: "Prendre rendez-vous",
      contact: "Contact",
      faq: "FAQ",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      admin: "Espace admin",
    },
    common: {
      bookAppointment: "Prendre rendez-vous",
      whatsapp: "WhatsApp",
      call: "Appeler",
      email: "Email",
      itinerary: "Itinéraire",
      viewDocuments: "Voir les documents à fournir",
      print: "Imprimer la liste",
      requestCallback: "Demander à être rappelé",
      required: "Obligatoire",
      submit: "Envoyer la demande",
      readMore: "En savoir plus",
      backHome: "Retour à l'accueil",
      loading: "Chargement...",
    },
    office: {
      name: "Maître Boudiaf Aimad Eddine",
      role: "Notaire",
      shortRole: "Cabinet notarial",
      tagline: "Cabinet notarial à Dély Ibrahim, Alger",
      addressLabel: "Adresse",
      address: "City RTT 04, Dély Ibrahim, Alger",
      phoneLabel: "Téléphone fixe",
      phoneFixed: "028 36 30 41",
      phoneMobileLabel: "Mobile / WhatsApp",
      phoneMobile: "+213 676 76 39 34",
      emailLabel: "Email",
      email: "opnotariale.boudiaf@gmail.com",
      hoursLabel: "Horaires",
      hours: "Dimanche – Jeudi, 08h30 – 16h30",
    },
    home: {
      eyebrow: "Office Notarial",
      h1: "Maître Boudiaf Aimad Eddine",
      subtitle: "Cabinet notarial à Dély Ibrahim, Alger",
      heroDesc:
        "Accompagnement rigoureux et discret pour vos actes immobiliers, successions, procurations, sociétés, hypothèques et formalités juridiques.",
      presentationTitle: "Un cabinet à votre écoute",
      presentationText:
        "Le cabinet notarial de Maître Boudiaf Aimad Eddine met son expertise juridique au service des particuliers et des professionnels. Rigueur, confidentialité et accompagnement personnalisé sont les fondements de notre pratique. Chaque dossier est traité avec la clarté et la précision que requièrent les actes notariés.",
      servicesOverlineTitle: "Nos domaines d'intervention",
      servicesTitle: "Nos Services",
      servicesSubtitle: "Un accompagnement notarial complet, structuré par domaines.",
      prepareTitle: "Préparer votre dossier",
      prepareSubtitle:
        "Consultez les pièces à fournir selon la nature de votre démarche.",
      whyTitle: "Pourquoi choisir le cabinet",
      why1: { title: "Rigueur juridique", desc: "Des actes préparés avec la plus grande précision." },
      why2: { title: "Confidentialité", desc: "Vos données et vos dossiers sont protégés." },
      why3: { title: "Clarté", desc: "Des explications simples et des étapes claires." },
      why4: { title: "Accompagnement personnalisé", desc: "Une écoute attentive, adaptée à votre situation." },
      why5: { title: "Disponibilité", desc: "Des réponses rapides par téléphone ou WhatsApp." },
      ctaTitle: "Besoin de nous rencontrer ?",
      ctaDesc: "Nous vous répondons rapidement et vous orientons dès votre première prise de contact.",
      mapTitle: "Nous trouver",
      mapSubtitle: "City RTT 04, Dély Ibrahim, Alger.",
    },
    cabinet: {
      eyebrow: "À propos",
      title: "Le Cabinet",
      intro:
        "Un cabinet notarial au service de la rigueur, de la confidentialité et de la sérénité des dossiers.",
      missionTitle: "Notre mission",
      missionText:
        "Assurer à nos clients une assistance juridique claire, honnête et complète, tout en garantissant la validité et la sécurité de leurs actes.",
      valuesTitle: "Nos valeurs",
      value1: "Probité",
      value2: "Discrétion",
      value3: "Clarté",
      value4: "Réactivité",
      engagementTitle: "Notre engagement",
      engagementText:
        "Nous nous engageons à vous accompagner avec disponibilité, écoute et respect. Chaque étape de votre dossier est expliquée, documentée et sécurisée.",
      stepsTitle: "Comment nous vous accompagnons",
      step1: { title: "Premier contact", desc: "Par téléphone, WhatsApp ou email." },
      step2: { title: "Analyse du dossier", desc: "Nous vérifions la démarche et les pièces à fournir." },
      step3: { title: "Préparation de l'acte", desc: "Rédaction rigoureuse et vérifications juridiques." },
      step4: { title: "Signature & formalités", desc: "Signature, enregistrement et suivi final." },
    },
    services: {
      eyebrow: "Nos domaines",
      title: "Nos Services",
      subtitle:
        "Un périmètre d'intervention large, organisé par domaines de compétence.",
      cta1: "Documents requis",
      cta2: "Prendre rendez-vous",
      categories: {
        immobilier: {
          title: "Immobilier",
          desc: "Actes de vente, promesse de vente, vente sur plan, donation, désistement, attestations notariales.",
          items: [
            "Actes de vente",
            "Promesse de vente",
            "Vente sur plan",
            "Donation",
            "Désistement",
            "Attestations notariales",
          ],
        },
        successions: {
          title: "Successions et patrimoine",
          desc: "Successions, partage, fridha, héritage, formalités successorales.",
          items: ["Successions", "Partage / Fridha", "Héritage", "Formalités successorales"],
        },
        procurations: {
          title: "Procurations et actes personnels",
          desc: "Procuration, reconnaissance de dette, dépôt, acquittement, contrats divers.",
          items: ["Procuration", "Reconnaissance de dette", "Dépôt", "Acquittement", "Contrats divers"],
        },
        societes: {
          title: "Sociétés et commerce",
          desc: "Création, modification et dissolution de société, gérance libre, contrat de travail.",
          items: [
            "Création de société",
            "Modification de société",
            "Dissolution de société",
            "Gérance libre de commerce",
            "Contrat de travail",
          ],
        },
        garanties: {
          title: "Garanties et sûretés",
          desc: "Hypothèque, mainlevée, gage.",
          items: ["Hypothèque", "Mainlevée", "Gage"],
        },
        certifications: {
          title: "Certifications et formalités",
          desc: "Certification, vérification documentaire, expertise juridique, documents notariés.",
          items: ["Certification", "Vérification documentaire", "Expertise juridique", "Documents notariés"],
        },
      },
    },
    documents: {
      eyebrow: "Préparer votre dossier",
      title: "Documents à fournir",
      subtitle:
        "Consultez la liste des pièces nécessaires selon la nature de votre démarche.",
      searchPlaceholder: "Rechercher une démarche...",
      allCategories: "Toutes les catégories",
      noResults: "Aucune démarche ne correspond à votre recherche.",
      noteTitle: "Note importante",
      note:
        "La liste des pièces peut varier selon la situation. Il est recommandé de confirmer votre dossier par téléphone ou par WhatsApp avant votre déplacement.",
      printHint: "Version imprimable disponible",
    },
    appointment: {
      eyebrow: "Rendez-vous",
      title: "Prendre rendez-vous",
      subtitle:
        "Communiquez-nous les informations ci-dessous. Nous vous recontactons rapidement pour confirmer votre créneau.",
      form: {
        fullName: "Nom complet",
        phone: "Téléphone",
        email: "Email",
        serviceType: "Type de démarche",
        serviceTypePlaceholder: "Sélectionnez une démarche",
        preferredDate: "Date souhaitée",
        preferredTime: "Heure souhaitée",
        message: "Message",
        messagePlaceholder: "Précisez votre demande (optionnel)",
        contactByPhone: "Je souhaite être contacté par téléphone",
        contactByWhatsapp: "Je souhaite être contacté sur WhatsApp",
        submit: "Envoyer la demande",
        submitting: "Envoi...",
        successTitle: "Demande envoyée",
        successText:
          "Merci, votre demande a bien été transmise au cabinet. Nous vous recontactons rapidement.",
        errorText: "Une erreur est survenue. Veuillez réessayer ou nous contacter par téléphone.",
      },
      services: [
        "Vente immobilière",
        "Succession",
        "Procuration",
        "Société",
        "Hypothèque",
        "Contrat",
        "Autre",
      ],
      alt: "Vous préférez un contact direct ?",
      contactHint:
        "Pour fixer votre rendez-vous au plus vite, contactez-nous directement par WhatsApp, par téléphone ou par email. Vous pouvez pré-remplir votre demande ci-dessous et l'envoyer en un clic sur WhatsApp.",
      sendViaWhatsapp: "Envoyer via WhatsApp",
    },
    contact: {
      eyebrow: "Contact",
      title: "Contactez le cabinet",
      subtitle:
        "Nous vous répondons par téléphone, WhatsApp ou email pendant les heures d'ouverture.",
      mapTitle: "Plan d'accès",
    },
    faq: {
      eyebrow: "Questions fréquentes",
      title: "FAQ",
      subtitle: "Les réponses aux questions les plus courantes.",
      items: [
        {
          q: "Quels documents dois-je apporter pour une vente ?",
          a: "La liste varie selon le type de bien et la situation des parties. Consultez notre page 'Documents à fournir' ou contactez-nous par WhatsApp pour une confirmation personnalisée.",
        },
        {
          q: "Dois-je prendre rendez-vous avant de me déplacer ?",
          a: "Oui, il est vivement recommandé de prendre rendez-vous afin que votre dossier soit traité dans les meilleures conditions.",
        },
        {
          q: "Le cabinet traite-t-il les successions ?",
          a: "Oui, le cabinet prend en charge les successions, partages, fridha et formalités successorales.",
        },
        {
          q: "Puis-je demander les documents par WhatsApp ?",
          a: "Oui, vous pouvez nous écrire sur WhatsApp pour obtenir la liste des pièces correspondant à votre démarche.",
        },
        {
          q: "Quels sont vos horaires ?",
          a: "Le cabinet est ouvert du dimanche au jeudi, de 08h30 à 16h30.",
        },
        {
          q: "Puis-je être orienté si je ne sais pas quelle procédure choisir ?",
          a: "Bien entendu. Contactez-nous par téléphone ou WhatsApp en décrivant brièvement votre besoin : nous vous orienterons vers la bonne démarche.",
        },
      ],
    },
    legal: {
      eyebrow: "Informations légales",
      title: "Mentions légales",
      editorTitle: "Éditeur du site",
      editorText:
        "Cabinet notarial Maître Boudiaf Aimad Eddine — City RTT 04, Dély Ibrahim, Alger. Téléphone : 028 36 30 41.",
      hostingTitle: "Hébergement",
      hostingText:
        "Ce site est hébergé via une infrastructure cloud sécurisée. Les coordonnées précises de l'hébergeur peuvent être communiquées sur demande.",
      ipTitle: "Propriété intellectuelle",
      ipText:
        "L'ensemble du contenu de ce site (textes, éléments graphiques, identité visuelle) est la propriété du cabinet ou de ses partenaires. Toute reproduction sans autorisation est interdite.",
      responsibilityTitle: "Responsabilité",
      responsibilityText:
        "Les informations publiées ont une portée informative générale. Elles ne sauraient se substituer à une consultation personnalisée auprès du cabinet.",
    },
    privacy: {
      eyebrow: "Confidentialité",
      title: "Politique de confidentialité",
      introTitle: "Données collectées",
      introText:
        "Les informations que vous nous transmettez via le formulaire de prise de rendez-vous (nom, téléphone, email, type de démarche, message) sont utilisées exclusivement pour traiter votre demande.",
      useTitle: "Utilisation",
      useText:
        "Ces données sont consultées uniquement par le cabinet. Elles ne sont ni vendues ni transmises à des tiers à des fins commerciales.",
      rightsTitle: "Vos droits",
      rightsText:
        "Vous pouvez demander à tout moment la consultation, la modification ou la suppression de vos données en nous contactant par téléphone ou par email.",
      retentionTitle: "Conservation",
      retentionText:
        "Les demandes sont conservées pour la durée nécessaire au traitement de votre dossier puis archivées ou supprimées.",
    },
    footer: {
      quickLinks: "Navigation",
      contact: "Contact",
      legal: "Informations",
      line: "Cabinet notarial — Rigueur, confidentialité et accompagnement personnalisé.",
      copyright: "© 2026 Maître Boudiaf Aimad Eddine — Tous droits réservés.",
    },
    admin: {
      title: "Gestion des demandes",
      subtitle: "Consultez et gérez les demandes de rendez-vous.",
      loginTitle: "Accès administrateur",
      loginDesc: "Connectez-vous avec votre compte Google pour accéder à l'espace de gestion.",
      loginBtn: "Se connecter avec Google",
      logout: "Se déconnecter",
      table: {
        date: "Date",
        name: "Nom",
        phone: "Téléphone",
        email: "Email",
        service: "Démarche",
        preferred: "Souhaité",
        message: "Message",
        status: "Statut",
        actions: "Actions",
      },
      statuses: {
        new: "Nouveau",
        contacted: "Contacté",
        confirmed: "Confirmé",
        done: "Terminé",
        cancelled: "Annulé",
      },
      noItems: "Aucune demande pour le moment.",
      unauthorized:
        "Votre compte n'a pas les autorisations nécessaires. Contactez l'administrateur du cabinet.",
    },
    whatsappMessages: {
      appointment: "Bonjour, je souhaite prendre rendez-vous.",
      succession: "Bonjour, je souhaite connaître les documents nécessaires pour une succession.",
      realEstate: "Bonjour, je souhaite obtenir des informations pour une vente immobilière.",
      general: "Bonjour, je souhaite obtenir des informations auprès du cabinet.",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      cabinet: "المكتب",
      services: "الخدمات",
      documents: "الوثائق المطلوبة",
      appointment: "طلب موعد",
      contact: "اتصل بنا",
      faq: "الأسئلة الشائعة",
      legal: "الإشعارات القانونية",
      privacy: "سياسة الخصوصية",
      admin: "لوحة الإدارة",
    },
    common: {
      bookAppointment: "طلب موعد",
      whatsapp: "واتساب",
      call: "اتصال",
      email: "بريد إلكتروني",
      itinerary: "الاتجاهات",
      viewDocuments: "عرض الوثائق المطلوبة",
      print: "طباعة القائمة",
      requestCallback: "طلب معاودة الاتصال",
      required: "إلزامي",
      submit: "إرسال الطلب",
      readMore: "اقرأ المزيد",
      backHome: "العودة إلى الرئيسية",
      loading: "جار التحميل...",
    },
    office: {
      name: "الأستاذ بودياف عماد الدين",
      role: "موثق",
      shortRole: "مكتب توثيق",
      tagline: "مكتب توثيق في دالي إبراهيم، الجزائر",
      addressLabel: "العنوان",
      address: "سيتي RTT 04، دالي إبراهيم، الجزائر",
      phoneLabel: "الهاتف الثابت",
      phoneFixed: "028 36 30 41",
      phoneMobileLabel: "الجوال / واتساب",
      phoneMobile: "+213 676 76 39 34",
      emailLabel: "البريد الإلكتروني",
      email: "opnotariale.boudiaf@gmail.com",
      hoursLabel: "ساعات العمل",
      hours: "الأحد – الخميس، 08:30 – 16:30",
    },
    home: {
      eyebrow: "مكتب التوثيق",
      h1: "الأستاذ بودياف عماد الدين",
      subtitle: "مكتب توثيق في دالي إبراهيم، الجزائر",
      heroDesc:
        "مرافقة دقيقة وسرية لعقودكم العقارية، المواريث، الوكالات، تأسيس الشركات، الرهون والإجراءات القانونية.",
      presentationTitle: "مكتب في خدمتكم",
      presentationText:
        "يضع مكتب الأستاذ بودياف عماد الدين خبرته القانونية في خدمة الأفراد والمهنيين. الصرامة، السرية والمتابعة الشخصية هي الأسس التي يرتكز عليها عملنا. يُعالج كل ملف بالوضوح والدقة اللذين تتطلبهما العقود الموثقة.",
      servicesOverlineTitle: "مجالات تدخلنا",
      servicesTitle: "خدماتنا",
      servicesSubtitle: "مرافقة توثيقية شاملة، منظمة حسب المجالات.",
      prepareTitle: "تحضير ملفكم",
      prepareSubtitle: "استعرضوا الوثائق المطلوبة حسب طبيعة الإجراء.",
      whyTitle: "لماذا تختاروننا",
      why1: { title: "صرامة قانونية", desc: "عقود محررة بأقصى قدر من الدقة." },
      why2: { title: "السرية", desc: "بياناتكم وملفاتكم محمية." },
      why3: { title: "الوضوح", desc: "شروحات بسيطة ومراحل واضحة." },
      why4: { title: "مرافقة شخصية", desc: "إنصات يتكيف مع وضعيتكم." },
      why5: { title: "التوفر", desc: "ردود سريعة عبر الهاتف أو واتساب." },
      ctaTitle: "هل تحتاجون لمقابلتنا؟",
      ctaDesc: "نرد عليكم بسرعة ونوجهكم منذ أول اتصال.",
      mapTitle: "موقعنا",
      mapSubtitle: "سيتي RTT 04، دالي إبراهيم، الجزائر.",
    },
    cabinet: {
      eyebrow: "عن المكتب",
      title: "المكتب",
      intro: "مكتب توثيق في خدمة الصرامة والسرية وراحة بال الملفات.",
      missionTitle: "مهمتنا",
      missionText:
        "تقديم مساعدة قانونية واضحة ونزيهة وشاملة لعملائنا مع ضمان صحة وأمن عقودهم.",
      valuesTitle: "قيمنا",
      value1: "النزاهة",
      value2: "السرية",
      value3: "الوضوح",
      value4: "سرعة الاستجابة",
      engagementTitle: "التزامنا",
      engagementText:
        "نلتزم بمرافقتكم بكل حضور وإنصات واحترام. تُشرح كل مرحلة من ملفكم، وتُوثق وتُؤمَّن.",
      stepsTitle: "كيف نرافقكم",
      step1: { title: "الاتصال الأول", desc: "عبر الهاتف، واتساب أو البريد." },
      step2: { title: "دراسة الملف", desc: "نتحقق من الإجراء والوثائق المطلوبة." },
      step3: { title: "تحضير العقد", desc: "تحرير دقيق وتحققات قانونية." },
      step4: { title: "التوقيع والإجراءات", desc: "التوقيع، التسجيل والمتابعة النهائية." },
    },
    services: {
      eyebrow: "مجالاتنا",
      title: "خدماتنا",
      subtitle: "مجال تدخل واسع، منظم حسب مجالات الاختصاص.",
      cta1: "الوثائق المطلوبة",
      cta2: "طلب موعد",
      categories: {
        immobilier: {
          title: "العقارات",
          desc: "عقود البيع، الوعد بالبيع، البيع على التصاميم، الهبة، التنازل، الشهادات الموثقة.",
          items: [
            "عقود البيع",
            "الوعد بالبيع",
            "البيع على التصاميم",
            "الهبة",
            "التنازل",
            "الشهادات الموثقة",
          ],
        },
        successions: {
          title: "المواريث والذمة",
          desc: "المواريث، القسمة، الفريضة، الإرث، الإجراءات الإرثية.",
          items: ["المواريث", "القسمة / الفريضة", "الإرث", "الإجراءات الإرثية"],
        },
        procurations: {
          title: "الوكالات والعقود الشخصية",
          desc: "الوكالة، الاعتراف بالدين، الإيداع، الإبراء، العقود المختلفة.",
          items: ["الوكالة", "الاعتراف بالدين", "الإيداع", "الإبراء", "عقود متنوعة"],
        },
        societes: {
          title: "الشركات والتجارة",
          desc: "تأسيس، تعديل وحل الشركات، التسيير الحر، عقد العمل.",
          items: [
            "تأسيس شركة",
            "تعديل شركة",
            "حل شركة",
            "التسيير الحر للمحل التجاري",
            "عقد العمل",
          ],
        },
        garanties: {
          title: "الضمانات والرهون",
          desc: "الرهن، رفع اليد، الرهن الحيازي.",
          items: ["الرهن", "رفع اليد", "الرهن الحيازي"],
        },
        certifications: {
          title: "الشهادات والإجراءات",
          desc: "التصديق، التحقق من الوثائق، الخبرة القانونية، الوثائق الموثقة.",
          items: ["التصديق", "التحقق من الوثائق", "الخبرة القانونية", "الوثائق الموثقة"],
        },
      },
    },
    documents: {
      eyebrow: "تحضير الملف",
      title: "الوثائق المطلوبة",
      subtitle: "استعرضوا الوثائق اللازمة حسب طبيعة الإجراء.",
      searchPlaceholder: "البحث عن إجراء...",
      allCategories: "جميع الفئات",
      noResults: "لا يوجد إجراء مطابق لبحثكم.",
      noteTitle: "ملاحظة مهمة",
      note:
        "قد تختلف قائمة الوثائق حسب الوضعية. يُنصح بتأكيد ملفكم عبر الهاتف أو واتساب قبل التنقل.",
      printHint: "نسخة للطباعة متوفرة",
    },
    appointment: {
      eyebrow: "موعد",
      title: "طلب موعد",
      subtitle: "قدموا لنا المعلومات أدناه. سنتصل بكم سريعاً لتأكيد الموعد.",
      form: {
        fullName: "الاسم الكامل",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        serviceType: "نوع الإجراء",
        serviceTypePlaceholder: "اختر إجراءً",
        preferredDate: "التاريخ المطلوب",
        preferredTime: "الساعة المطلوبة",
        message: "الرسالة",
        messagePlaceholder: "حددوا طلبكم (اختياري)",
        contactByPhone: "أرغب في الاتصال عبر الهاتف",
        contactByWhatsapp: "أرغب في الاتصال عبر واتساب",
        submit: "إرسال الطلب",
        submitting: "جاري الإرسال...",
        successTitle: "تم إرسال الطلب",
        successText: "شكراً، تم إرسال طلبكم إلى المكتب. سنتواصل معكم قريباً.",
        errorText: "حدث خطأ. يرجى المحاولة مجدداً أو الاتصال هاتفياً.",
      },
      services: [
        "بيع عقاري",
        "ميراث",
        "وكالة",
        "شركة",
        "رهن",
        "عقد",
        "أخرى",
      ],
      alt: "تفضلون تواصلاً مباشراً ؟",
      contactHint:
        "لتحديد موعدكم بسرعة، تواصلوا معنا مباشرة عبر واتساب أو الهاتف أو البريد. يمكنكم ملء طلبكم أدناه وإرساله بنقرة واحدة عبر واتساب.",
      sendViaWhatsapp: "إرسال عبر واتساب",
    },
    contact: {
      eyebrow: "اتصال",
      title: "اتصلوا بالمكتب",
      subtitle: "نرد عبر الهاتف، واتساب أو البريد خلال ساعات العمل.",
      mapTitle: "خطة الوصول",
    },
    faq: {
      eyebrow: "الأسئلة الشائعة",
      title: "الأسئلة الشائعة",
      subtitle: "إجابات على الأسئلة الأكثر تكراراً.",
      items: [
        {
          q: "ما الوثائق التي يجب إحضارها للبيع ؟",
          a: "تختلف القائمة حسب نوع العقار ووضعية الأطراف. استعرضوا صفحة 'الوثائق المطلوبة' أو تواصلوا معنا عبر واتساب للتأكيد.",
        },
        {
          q: "هل يجب أخذ موعد قبل التنقل ؟",
          a: "نعم، يُستحسن بشدة أخذ موعد حتى تتم معالجة ملفكم في أفضل الظروف.",
        },
        {
          q: "هل يعالج المكتب المواريث ؟",
          a: "نعم، يتكفل المكتب بالمواريث، القسمة، الفريضة والإجراءات الإرثية.",
        },
        {
          q: "هل يمكنني طلب الوثائق عبر واتساب ؟",
          a: "نعم، يمكنكم مراسلتنا عبر واتساب للحصول على قائمة الوثائق المناسبة لإجرائكم.",
        },
        {
          q: "ما هي ساعات العمل ؟",
          a: "المكتب مفتوح من الأحد إلى الخميس، من 08:30 إلى 16:30.",
        },
        {
          q: "هل يمكن توجيهي إذا لم أعرف الإجراء المناسب ؟",
          a: "بالتأكيد. تواصلوا معنا عبر الهاتف أو واتساب مع وصف مختصر لحاجتكم، وسنوجهكم للإجراء المناسب.",
        },
      ],
    },
    legal: {
      eyebrow: "معلومات قانونية",
      title: "الإشعارات القانونية",
      editorTitle: "ناشر الموقع",
      editorText:
        "مكتب التوثيق الأستاذ بودياف عماد الدين — سيتي RTT 04، دالي إبراهيم، الجزائر. الهاتف: 028 36 30 41.",
      hostingTitle: "الاستضافة",
      hostingText:
        "يُستضاف هذا الموقع عبر بنية سحابية آمنة. يمكن تقديم تفاصيل المضيف عند الطلب.",
      ipTitle: "الملكية الفكرية",
      ipText:
        "جميع محتويات هذا الموقع (نصوص، عناصر رسومية، هوية بصرية) ملكية للمكتب أو شركائه. يُمنع أي استنساخ بدون إذن.",
      responsibilityTitle: "المسؤولية",
      responsibilityText:
        "المعلومات المنشورة ذات طابع إعلامي عام ولا تغني عن استشارة شخصية مع المكتب.",
    },
    privacy: {
      eyebrow: "الخصوصية",
      title: "سياسة الخصوصية",
      introTitle: "البيانات المجمعة",
      introText:
        "المعلومات التي ترسلونها عبر نموذج الموعد (الاسم، الهاتف، البريد، نوع الإجراء، الرسالة) تُستخدم حصرياً لمعالجة طلبكم.",
      useTitle: "الاستخدام",
      useText:
        "يطلع على هذه البيانات المكتب فقط. لا تُباع ولا تُنقل إلى أطراف ثالثة لأغراض تجارية.",
      rightsTitle: "حقوقكم",
      rightsText:
        "يمكنكم في أي وقت طلب الاطلاع على بياناتكم أو تعديلها أو حذفها عبر الاتصال بنا هاتفياً أو بالبريد.",
      retentionTitle: "المدة",
      retentionText:
        "تُحفظ الطلبات للمدة اللازمة لمعالجة ملفكم ثم تُؤرشف أو تُحذف.",
    },
    footer: {
      quickLinks: "التصفح",
      contact: "الاتصال",
      legal: "معلومات",
      line: "مكتب توثيق — الصرامة، السرية والمرافقة الشخصية.",
      copyright: "© 2026 الأستاذ بودياف عماد الدين — جميع الحقوق محفوظة.",
    },
    admin: {
      title: "إدارة الطلبات",
      subtitle: "استعرضوا وأديروا طلبات المواعيد.",
      loginTitle: "دخول الإدارة",
      loginDesc: "سجلوا الدخول بحساب Google للوصول إلى فضاء الإدارة.",
      loginBtn: "الدخول بحساب Google",
      logout: "خروج",
      table: {
        date: "التاريخ",
        name: "الاسم",
        phone: "الهاتف",
        email: "البريد",
        service: "الإجراء",
        preferred: "مطلوب",
        message: "الرسالة",
        status: "الحالة",
        actions: "إجراءات",
      },
      statuses: {
        new: "جديد",
        contacted: "تم التواصل",
        confirmed: "مؤكد",
        done: "منتهٍ",
        cancelled: "ملغى",
      },
      noItems: "لا توجد طلبات حالياً.",
      unauthorized: "حسابكم لا يملك الصلاحيات. اتصلوا بمسؤول المكتب.",
    },
    whatsappMessages: {
      appointment: "السلام عليكم، أرغب في طلب موعد.",
      succession: "السلام عليكم، أرغب في معرفة الوثائق اللازمة للميراث.",
      realEstate: "السلام عليكم، أرغب في الحصول على معلومات حول بيع عقاري.",
      general: "السلام عليكم، أرغب في الحصول على معلومات من المكتب.",
    },
  },
};
